<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <path
            fill="#205B98"
            d="M14.223 24.217L26.153 27.083 26.153 4.849 14.223 7.716z"
            transform="translate(2)"
          />
          <path
            fill="#5294CF"
            d="M26.152 4.849L28.444 5.987 28.444 25.952 26.152 27.089zM14.223 24.217L2.293 27.083 2.293 4.849 14.223 7.716z"
            transform="translate(2)"
          />
          <path
            fill="#205B98"
            d="M2.293 4.849L0 5.987 0 25.952 2.293 27.089z"
            transform="translate(2)"
          />
          <path
            fill="#5294CF"
            d="M17.277 31.556L21.806 29.308 21.806 2.692 17.277 0.444 15.854 15.24z"
            transform="translate(2)"
          />
          <path
            fill="#205B98"
            d="M11.168 31.556L6.639 29.308 6.639 2.692 11.168 0.444 12.592 15.188z"
            transform="translate(2)"
          />
          <path
            fill="#2D72B8"
            d="M11.168 0.444H17.277V31.555H11.168z"
            transform="translate(2)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RedshiftLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
